// extracted by mini-css-extract-plugin
export default {"spinnerOverLay":"spinner_spinnerOverLay__pyQWJ","loadingSpinner":"spinner_loadingSpinner__aZSdE","spin":"spinner_spin__uRPDS"};